import { featureNames } from "@/src/constants/globalConstants";

export const auditEntities = {
  LEAD: "lead",
  CONTACT: "contact",
  SEQUENCE: "sequence",
};

export const auditEntityTypes = {
  SEQUENCE: "Sequence",
  SEQUENCE_STEPS: "sequence_steps",
  SEQUENCE_STEP_MESSAGES: "SequenceStepMessage",
  SEQUENCE_EXECUTION: "SequenceExecution",
  SEQUENCE_SETTING: "SequenceSetting",
  SEQUENCE_STEP: "SequenceStep",
};

export const auditOperationType = {
  UPDATE: "update",
  INSERT: "insert",
  DELETE: "delete",
};

export const auditActionBySource = {
  API: "api",
  BACKGROUND_JOB: "background_job",
};

export const operationLabels = {
  update: "updated",
  insert: "created",
  delete: "deleted",
};

export const statusLabels = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  IN_ACTIVE: "inactive",
  PAUSED: "paused",
  DRAFT: "draft",
};

export const fieldLabels = {
  name: "name",
  status: "status",
  title: "title",
  description: "description",
  subject: "subject",
  content: "content",
  timezone: "timezone",
  start_time: "start time",
  end_time: "end time",
  position: "position",
  type: "type",
  permission: "permission",
};

export const entityDisplayNames = {
  sequence: featureNames.SEQUENCES,
  sequence_steps: "sequence step",
  sequence_step_messages: "sequence step message",
  sequenceexecution: "sequence execution",
  sequencesetting: "sequence setting",
  sequencestep: "sequence step",
  lead: "lead",
  contact: "contact",
};

export const stepTypeDisplayNames = {
  EMAIL: "email",
  LINKEDIN_INMAIL: "LinkedIn InMail",
  LINKEDIN_INVITE: "LinkedIn invite",
  LINKEDIN_MESSAGE: "LinkedIn message",
  MARKET_RESEARCH: "market research",
  MULTI_THREADING: "multi-threading",
  NEXT_BEST_ACTION: "next best action",
  PHONE_CALL: "phone call",
  QUALIFICATION: "qualification",
  VOICE: "voice",
};

export const sequenceSettingFields = {
  TIMEZONE: "timezone",
  START_TIME: "start_time",
  END_TIME: "end_time",
  ENABLE_MAILBOX_ROTATION: "enable_mailbox_rotation",
  ROUND_ROBIN_ENABLED: "round_robin_enabled",
  CALL_ROUND_ROBIN_ENABLED: "call_round_robin_enabled",
  ADD_UNSUBSCRIBE_LINK: "add_unsubscribe_link",
  SKIP_EMAIL_VALIDATION: "skip_email_validation",
  CATCH_ALL_ENABLED: "catch_all_enabled",
  REMOVE_ON_MEETING_BOOKED: "remove_on_meeting_booked",
  CALL_REPLY_EXIT_ENABLED: "call_reply_exit_enabled",
  EXCLUDE_ADDED_ENTITIES: "exclude_added_entities",
  ENRICH_PHONE_BY_DEFAULT: "enrich_phone_by_default",
  EXCLUDE_CRM_LISTS: "exclude_crm_lists",
  EXCLUDE_PEOPLE_FROM_LISTS: "exclude_people_from_lists",
  UNSUBSCRIBE_MESSAGE: "unsubscribe_message",
  ROUND_ROBIN_TEAM_ID: "round_robin_team_id",
  CALL_ROUND_ROBIN_TEAM_ID: "call_round_robin_team_id",
};

export const ignoredFields = ["id", "created_at", "updated_at", "workspace_id"];

export const timeThreshold = {
  FIVE_MINUTES: 5 * 60 * 1000,
};

export const groupableAuditCriteria = {
  entityTypes: [auditEntityTypes.SEQUENCE_EXECUTION],
  operationTypes: [auditOperationType.INSERT, auditOperationType.DELETE],
  targetEntityTypes: [auditEntities.LEAD, auditEntities.CONTACT],
};

export const operationConfig = {
  [auditOperationType.INSERT]: {
    action: "added",
    preposition: "to",
    pastTense: "added",
  },
  [auditOperationType.DELETE]: {
    action: "removed",
    preposition: "from",
    pastTense: "removed",
  },
  [auditOperationType.UPDATE]: {
    action: "updated",
    preposition: "in",
    pastTense: "updated",
  },
};

export const entityTypeMapping = {
  [auditEntities.LEAD]: {
    singular: "contact/lead",
    plural: "contacts/leads",
  },
  [auditEntities.CONTACT]: {
    singular: "contact/lead",
    plural: "contacts/leads",
  },
};

export const entityTypeGrouping = {
  CONTACT_LEAD: "contact_lead",
};

export const allowedActionBySources = [auditActionBySource.API];

export const actionBySourceConfig = {
  [auditActionBySource.API]: {
    label: "API",
    description: "Action performed via API",
    allowedOperations: [
      auditOperationType.INSERT,
      auditOperationType.UPDATE,
      auditOperationType.DELETE,
    ],
  },
  [auditActionBySource.BACKGROUND_JOB]: {
    label: "Background Job",
    description: "Action performed by system background job",
    allowedOperations: [auditOperationType.INSERT, auditOperationType.DELETE],
  },
};

export const backgroundJobAllowedCombinations = [
  {
    entityType: auditEntityTypes.SEQUENCE_EXECUTION,
    operationType: auditOperationType.INSERT,
  },
  {
    entityType: auditEntityTypes.SEQUENCE_EXECUTION,
    operationType: auditOperationType.DELETE,
  },
];

export const detailsFieldMapping = {
  call_round_robin_team_id: {
    detailsField: "call_round_robin_team_id_details",
    nameProperty: "name",
    label: "call round-robin team",
  },
  round_robin_team_id: {
    detailsField: "round_robin_team_id_details",
    nameProperty: "name",
    label: "round-robin team",
  },
};
